import request, { ResponseProps } from '@/utils/request';

import { ApiResult } from '.';

interface machineType {
  url: string;
  imageMd5: string;
}
/**
 * 图片审核
 * @param data
 * @returns
 */
export const fetchMachine = async (data: machineType): Promise<ApiResult<any>> => {
  const res = await request('/api/rest/dlt/review/machine/sync', {
    method: 'POST',
    data,
  });
  return res;
};

export type ParamsType = {
  title: string; // 标题
  videoUrl: string; // 原视频 url
  imageUrl: string; // 图片 url
  previewUrl: string; // 封面图
  needAvatar: boolean; // 是否需要同步制作数字人
  gender: number; // 1-男性 2-女性，需要制作数字人时必传
  duration: number; // 视频时长，单位毫秒
  piplineName: string; // 加了这个字段才会开启这个新版本模式，即脸部清晰度系数
  blendAlpha: number; // 系数越大，脸部越清晰
};

/**
 * 换脸
 * @param data
 * @returns
 */
export const fetchFaceswap = async (data: ParamsType): Promise<ApiResult<any>> => {
  const res = await request('/api/rest/dlt/cloud/faceswap', {
    method: 'POST',
    data,
  });
  return res;
};

/**
 * 批量换脸
 * @param data
 * @returns
 */
export const batchFaceSwap = async (data: {
  batchList: ParamsType[];
}): Promise<ApiResult<{ parentId: number }>> => {
  const res = await request('/api/rest/dlt/cloud/batch/faceswap', {
    method: 'POST',
    data,
  });
  return res;
};

/**
 * 任务列表
 * @param data
 * @returns
 */
export const getTaskList = async (data: {}): Promise<ResponseProps> => {
  const res: ResponseProps = await request('/api/rest/dhc/task/list', {
    method: 'POST',
    data,
  });
  return res;
};

// 删除任务（主要是失败的）
export const deleteTask = async (data: {}): Promise<ResponseProps> => {
  const res = await request('/api/rest/dhc/task/delete', {
    method: 'POST',
    data,
  });
  return res;
};

// 删除资产(素材)
export const deleteAsset = async (data: {}): Promise<ResponseProps> => {
  const res: ResponseProps = await request('/api/rest/dlt/asset/del', {
    method: 'POST',
    data,
  });
  return res;
};

export enum FaceSwapErrorCode {
  // 人脸图片审核失败
  image_verify_failed = 'image_verify_failed',
  // 视频换脸失败
  video_swap_failed = 'video_swap_failed',
  // 图片人脸检测失败
  img_detected_failed = 'img_detected_failed',
  // 视频人脸检测失败
  video_detected_failed = 'video_detected_failed',
  // 手动取消
  manual_cancel = 'manual_cancel',
}

interface EventResultType {
  engineCode: string;
  engineMessage: string;
  taskState: number;
  extraEventResult: string;
  businessId: number;
  fileUrl: string;
  duration: number;
}

// 视频时长截取 & 视频图片人脸检测
export const videoFaceSwap = async (
  videoUrl: string,
  imageUrl: string,
  duration: number = 6000,
): Promise<string> => {
  const events = [
    {
      process_event_type: 190,
      video_transcoding2_event: {
        video_url: videoUrl,
        type: 1,
      },
    },
    {
      process_event_type: 169,
      algo_video_capture_event: {
        // video_url: videoUrl,
        duration: duration,
        max_resolution_ratio: '1080p',
      },
    },
    {
      process_event_type: 168,
      algo_image_video_landmark_event: {
        image_url: imageUrl,
        video_land_mark_point_type: 0,
      },
    },
    {
      process_event_type: 38,
      video_face_merge_trt_event: {
        pipline_name: 'blend',
        need_cover: true,
      },
    },
  ];

  const lookup = [
    {
      event: 'video_transcoding2_event',
      map: {},
    },
    {
      event: 'algo_video_capture_event',
      map: {
        video_url: '$.video_transcode2_event_result.output_video_url',
      },
    },
    {
      event: 'algo_image_video_landmark_event',
      map: {
        video_url: '$.algo_video_capture_result.video_url',
      },
    },
    {
      event: 'video_face_merge_trt_event',
      map: {
        theme_url: '$.algo_video_capture_result.video_url',
        video_landmarks: '$.algo_image_video_landmarks_result.lmk_url',
      },
    },
  ];

  const res = await request('/api/rest/dlt/cloud/assemble/make', {
    method: 'POST',
    data: {
      events: JSON.stringify(events),
      lookup: JSON.stringify(lookup),
      datas: [{ url: imageUrl }],
    },
  });

  return new Promise(async (resolve, reject) => {
    if (res && res.success) {
      resolve(res.data.businessId);
    } else {
      reject({ code: FaceSwapErrorCode.video_swap_failed });
    }
  });
};

/**
 * 查询Event结果
 * state 0-已成功提交给引擎，1-未能成功发给引擎，2-引擎回调返回成功，3-引擎回调返回失败,8-任务已取消
 */
export const fetchEventResult = async (
  businessId: string,
): Promise<ApiResult<EventResultType>> => {
  const res = await request('/api/rest/dlt/cloud/make/queryResult', {
    method: 'POST',
    data: { businessId },
  });
  return res;
};

//  3.0
export const submitFaceSwap = async (data: any) => {
  return await request('/api/rest/dlt/f/cloud/batch/faceswap', {
    method: 'POST',
    data,
  });
};
export const submitHeadSwap = async (data: any) => {
  return await request('/api/rest/dlt/f/cloud/headswap', {
    method: 'POST',
    data,
  });
};
